import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Navbar, Nav } from 'react-bootstrap';
import Scroller from './Scroller';
import CompletedProjectScroller from './CompleteProjectScroller';
import { DAO, Funding, mintNFT } from '../../../assets/img';
import { Game, Art, ArtsImg, FoodImg, GameImg, Food, Comic, Music } from '../../../assets/video/index';
import { Link } from 'react-router-dom';
import ActiveCampaign from './ActiveCampaign';

const LaunchPad = () => {
    // States for tabs and filters
    const [count, setCount] = useState(0);
    const [activeTab, setActiveTab] = useState('All Campaigns');
    const [campaignStatus, setCampaignStatus] = useState('Active');
     // props.set(false);
    const [subTitle, setSubTitle] = useState(
        {
            "video": Art,
            "poster": ArtsImg
        });

    // Example KYC data (you should replace this with dynamic data)
    const kycData = [
        {
            imgSrc: mintNFT,
            title: "Mint NFT",
            description: "Mint your mark on the blockchain—create and launch unique digital assets as NFTs!"
        },
        {
            imgSrc: DAO,
            title: "Create DAO",
            description: "Build the future of decentralized governance—launch your own DAO powered by smart contracts!"
        },
        {
            imgSrc: Funding,
            title: "Get Funds",
            description: "Secure funding your way—Token Sales, Decentralized Crowdfunding, Grants, VC backing, Community Support, and DeFi-powered growth!"
        }
    ];
    // Example campaign data (you should replace this with dynamic data)
    const campaigns = [
        { title: 'Campaign 1', status: 'Active', type: 'All Campaigns' },
        { title: 'Campaign 2', status: 'Closed', type: 'My Campaigns' },
        { title: 'Campaign 3', status: 'Active', type: 'All Campaigns' },
        { title: 'Campaign 4', status: 'Closed', type: 'My Campaigns' },
    ];

    // Filter campaigns based on active tab and status
    const filteredCampaigns = campaigns.filter(campaign => {
        return (
            (campaign.type === activeTab) &&
            (campaign.status === campaignStatus || campaignStatus === 'All')
        );
    });

    const Arrr = [
        { link: '/launchpad', title: 'Arts' },
        { link: '/launchpad', title: 'Comics & Illustration' },
        { link: '/launchpad', title: 'Design & Tech' },
        { link: '/launchpad', title: 'Film' },
        { link: '/launchpad', title: 'Food & Craft' },
        { link: '/launchpad', title: 'Games' },
        { link: '/launchpad', title: 'Music' },
        { link: '/launchpad', title: 'Publishing' },
    ]

    const checkTitle = (sub) => {
        if (sub === "Games") {
            setSubTitle({ "video": Game, "poster": GameImg })
        }
        else if (sub === "Food & Craft") {
            setSubTitle({ "video": Food, "poster": FoodImg })
        }
        else if (sub === "Arts") {
            setSubTitle({ "video": Art, "poster": ArtsImg })
        }
        else if (sub === "Comics & Illustration") {
            setSubTitle({ "video": Comic, "poster": ArtsImg })

        }
        else if (sub === "Music") {
            setSubTitle({ "video": Music, "poster": ArtsImg })

        }
    }
    const handleChange = (e) => {
        checkTitle(e.target.value);
    };

    const dsss = () => {
        setTimeout(() => {
            checkTitle("Arts")
        },
            9500)
        setTimeout(() => {
            checkTitle("Comics & Illustration")
        }, 25000)
        setTimeout(() => {
            checkTitle("Food & Craft")
        }, 38500)
        setTimeout(() => {
            checkTitle("Games")
            if (count === 0) {
                setCount(1)
            }
            else {
                setCount(0)
            }
        }, 52000)

        setTimeout(() => {
            checkTitle("Music")
            if (count === 0) {
                setCount(1)
            }
            else {
                setCount(0)
            }
        }, 72000)
    };

    useEffect(() => {
        dsss()
    }, [count])

    return (
        <>
            <div className="launchpad1">
                <div className="launchpad1_All">
                    <div className='videoBlock'>
                        <video className='vid' poster={subTitle.poster}
                            src={subTitle.video} autoPlay muted loop id='myVideo'>
                        </video>
                        <div className="launchpad1_cover_img" style={{ position: "relative" }}>
                            <div className="launchpad1__header" id="myHeader">
                                <Navbar collapseOnSelect className="launchpad_subnavbar" style={{ justifyContent: 'center' }} expand="lg" >
                                    <div>
                                        <div className='p-0 m-0' style={{ width: "90vw" }}>
                                            <div className="w-100 launchpad_searchForCat">
                                                <select onChange={(e) => handleChange(e)} name='options' className="launchpad_selectCat ps-2" >
                                                    <option className="">
                                                        Select Category</option>
                                                    {Arrr.map((data, i) =>
                                                        <option name='options' value={data.title}>{data.title}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="p-0 m-0 w-100">
                                            <Navbar.Collapse id="responsive-navbar-nav">
                                                <Nav className="me-auto launchpad_navAll">
                                                    {Arrr.map((data, i) => (
                                                        <>
                                                            <Link className='' to={data.link} onClick={() => checkTitle(data.title)}>
                                                                <span className='nav-link-ltr1 px-3 p4'>
                                                                    <span className='nav-link-ltr1_margin'>
                                                                        {data.title}
                                                                    </span>
                                                                </span>
                                                            </Link>
                                                        </>
                                                    ))}
                                                </Nav>
                                            </Navbar.Collapse>
                                        </div>
                                    </div>
                                </Navbar>
                            </div>
                            <div className="" >
                                <div className='mt-5'>
                                    <h2 className='text-center' style={{ fontWeight: 'bold', color: "#fff", margin: "auto" }}>
                                    Shape the future—invest in groundbreaking NFTs!
                                    </h2>
                                </div>
                                <div className=" mt-3" >
                                    <div className='text-center' style={{ width: "50vw", marginLeft: "25vw" }}>
                                        <span className='fs-5 text-white ' style={{ 'textIndent': '50px' }}>
                                        Step into the future of digital ownership! Invest in the next wave of NFT innovation—art, music, virtual real estate, and beyond. Fuel the creators of tomorrow and be part of the revolution with DtoC!
                                         {/* <span className="launchpad1_Launch_heading_text_dis p3">
                                                NFTs represent unique digital assets such as artwork, music, virtual real estate, or collectibles.
                                            </span> */}
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="w-100 launchpad1_Launch_heading_search">
                                    <span className="Launch_Coming1 w-100" style={{ fontWeight: 'bold', margin: "auto" }}>
                                        <div className="input-group w-100">
                                            <div className="form-outline w-100 serachForBest">
                                                <input type="search" placeholder="Search" id="form1" className="p2 form-control d-flex align-items-center justify-centent-center rounded-pill SearchForBestINput" />
                                                <div style={{ position: "absolute", left: "1rem", top: "0.25rem" }}>
                                                    <ImSearch className="searchIconsa text-dark" style={{ fontSize: "0.9rem" }} />
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </div> */}
                         
                                <div className='d-flex align-items-center justify-content-center' style={{ position: "absolute", bottom: "0", left: "0", right: "0" }}>
                                    <Link to="/create-campaign">
                                        <button className='btn btn-lg btn-grad m-3' >
                                            Start Campaign
                                        </button>
                                    </Link>
                                    <button className='btn btn-lg btn-grad border rounded-sm m-3'>
                                        Learn More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-5">
                        <h1 className="text-center">Marketplace</h1>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-start">
                                <Button

                                    variant={activeTab === 'All Campaigns' ? 'dark' : 'light'}
                                    onClick={() => setActiveTab('All Campaigns')}
                                >
                                    All Campaigns
                                </Button>
                                <Button
                                    variant={activeTab === 'My Campaigns' ? 'dark' : 'light'}
                                    onClick={() => setActiveTab('My Campaigns')}
                                    className="ml-2"
                                >
                                    My Campaigns
                                </Button>
                            </div>
                            <div className="d-flex align-items-center justify-content-start">
                                <Button
                                    variant={campaignStatus === 'Active' ? 'dark' : 'light'}
                                    onClick={() => setCampaignStatus('Active')}
                                >
                                    Active
                                </Button>
                                <Button
                                    variant={campaignStatus === 'Closed' ? 'dark' : 'light'}
                                    onClick={() => setCampaignStatus('Closed')}
                                    className="ml-2"
                                >
                                    Closed
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Display filtered campaigns */}
                    <div className="container">
                        <div>
                            <Row className='d-flex launchpad__trendingScroller'>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h2 className='my-4'>
                                        {activeTab === 'All Campaigns' ? 'All Campaigns' : 'My Campaigns'}
                                    </h2>
                                </div>
                                {filteredCampaigns.length > 0 ? (
                                    // filteredCampaigns.slice(0).map((campaign, index) => (
                                        <div>
                                            {/* <Scroller campaign={campaign} /> */}
                                            <ActiveCampaign category={activeTab} />
                                        </div>
                                    // ))
                                ) : (
                                    <p>No campaigns available.</p>
                                )}
                            </Row>
                            {/* View All button for Campaigns */}
                            <div className="text-center">
                                <Button variant="primary" onClick={() => alert('View All Campaigns')}>
                                    View All Campaigns
                                </Button>
                            </div>
                        </div>

                        <div>
                            <Row className='d-flex launchpad__trendingScroller'>
                                <h2 className='my-4'>Trending and Latest ILO Projects</h2>
                                <Scroller />
                            </Row>
                            {/* View All button for Trending Projects */}
                            <div className="text-center mt-4">
                                <Button variant="primary" onClick={() => alert('View All ILO Projects')}>
                                    View All ILO Projects
                                </Button>
                            </div>
                        </div>

                        <div>
                            <Row className='d-flex launchpad__trendingScroller'>
                                <h2 className='my-4'>Completed Projects</h2>
                                <CompletedProjectScroller />
                            </Row>
                            {/* View All button for Completed Projects */}
                            <div className="text-center mt-4">
                                <Button variant="primary" onClick={() => alert('View All Completed Projects')}>
                                    View All Completed Projects
                                </Button>
                            </div>
                        </div>
                        <div className="px-4 mt-4" >
                            {/* <video className='vid1' poster={subTitle.poster}
                            src={subTitle.video} autoPlay muted loop id='myVideo1'>
                        </video> */}
                            <h2 className='mb-2 ' style={{ textTransform: "capitalize" }} >
                                More Accessibility
                            </h2>
                            <Row className='yc' g={3}>
                                {kycData.map((item, index) => (
                                    <Col lg="4" sm="12" className="kyc1 text-center mb-4" key={index}>
                                        <div className='kyc1 py-2 text-center m-3' style={{ backgroundColor: 'white', height: "35vh" }}>
                                            <img className='lockded' src={item.imgSrc} alt={item.title} />
                                            <h2>{item.title}</h2>
                                            <span className='kycSpan p3'>{item.description}</span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LaunchPad;
